<template>
  <el-dropdown
    id="user-center"
    :hide-timeout="200"
    :teleported="true"
    popper-class="dropdown-no-arrow UserMenu-popper"
  >
    <Row class="w-32px h-32px rd-full header-round-hover-bg cursor-pointer" x="c" y="c">
      <IconSvg class="text-white title transition pointer  font-20" name="icon-my" />
    </Row>

    <template #dropdown>
      <el-dropdown-menu class="user-menu-list" x="c">
        <Column x="s" class="user-menu-header w-100b label">
          <div v-if="tips" class="text-20px weight-700 m-b-6">{{ tips }}</div>
          <CopyToClip class="text-9b text-12px" :size="14" :value="userStore?.info?.uid">
            <template #front>
              <span class="m-r-6">UID:{{ userStore?.info?.uid }}</span>
            </template>
          </CopyToClip>
        </Column>
        <div class="user-menu-divider" />

        <el-dropdown-item
          id="to-userOverview"
          x="s"
          class="appheader-dropdown-item"
          :class="{'user-menu-item-active':businessPath.includes('userOverview')}"
          @click="() => toRouter('/psersonalCenter/userOverview')"
        >
          <img class="user-menu-icon" src="@/image/userCenter/menu/userOverviewIcon.png" alt="">
          <span class="weight-700" v-inmodule="['/psersonalCenter/userOverview']">{{ $t("wallet.userOverview") }}</span>
        </el-dropdown-item>

        <el-dropdown-item
          id="to-accountSecurity"
          x="s"
          class="appheader-dropdown-item"
          :class="{'user-menu-item-active':businessPath.includes('accountSecurity')}"
          @click="() => toRouter('/psersonalCenter/accountSecurity')"
        >
          <img class="user-menu-icon" src="@/image/userCenter/menu/accountSecurityIcon.png" alt="">
          <span class="weight-700" v-inmodule="['/psersonalCenter/accountSecurity']">{{ $t("wallet.accountSecurity") }}</span>
        </el-dropdown-item>

        <el-dropdown-item
          id="to-authentication"
          x="s"
          class="appheader-dropdown-item"
          :class="{'user-menu-item-active':businessPath.includes('authentication')}"
          @click="() => toRouter('/psersonalCenter/authentication')"
        >
          <img class="user-menu-icon" src="@/image/userCenter/menu/authenticationIcon.png" alt="">
          <span class="weight-700" v-inmodule="['/psersonalCenter/authentication']">{{ $t("wallet.authentication") }}</span>
        </el-dropdown-item>

        <el-dropdown-item
          id="to-invateRebate"
          x="s"
          class="appheader-dropdown-item"
          :class="{'user-menu-item-active':businessPath.includes('rebate')}"
          @click="() => toRouter('/rebate')"
        >
          <img class="user-menu-icon" src="@/image/userCenter/menu/inviteRebateIcon.png" alt="">
          <span class="weight-700" v-inmodule="['/rebate']">{{ $t("wallet.invateRebate") }}</span>
        </el-dropdown-item>

        <el-dropdown-item
          x="s"
          class="appheader-dropdown-item"
          :class="{'user-menu-item-active':businessPath.includes('couponCenter')}"
          @click="() => toRouter('/psersonalCenter/couponCenter')"
        >
          <img class="user-menu-icon" src="@/image/userCenter/menu/couponCenterIcon.png" alt="">
          <span class="weight-700">{{ $t("couponCenter.couponCenter") }}</span>
        </el-dropdown-item>

        <el-dropdown-item
          v-if="userStore.bdUser == 1"
          id="to-invateRebate"
          x="s"
          class="appheader-dropdown-item"
          :class="{'user-menu-item-active':businessPath.includes('psersonalCenter/promotionPlan')}"
          @click="() => toRouter('/psersonalCenter/promotionPlan')"
        >
          <img class="user-menu-icon" src="@/image/userCenter/menu/promotionPlanIcon.png" alt="">
          <span class="weight-700">{{ $t("promotionPlan.promotionPlan") }}</span>
        </el-dropdown-item>

        <Row id="appHeader-logout" x="s" class="user-menu-logout border-t m-t-10" @click="userStore.logout">
          <img class="user-menu-icon" src="@/image/userCenter/menu/log-out.png" alt="">
          <span class="text-16151A text-14px">{{ $t("user.logout") }}</span>
        </Row>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>

<script setup>
import { getBusinessPath } from '@/utils/localeRoute.js'

const route = useRoute()
const businessPath = $computed(() => getBusinessPath(route.path))
const userStore = useUserStore()

const tips = $computed(() => {
  if (userStore?.info?.nickName) {
    return userStore?.info?.nickName
  }
  if (userStore?.info?.phone) {
    return $f.hidePhone(userStore?.info?.phone)
  }
  if (userStore?.info?.email) {
    return $f.hideEmail(userStore?.info?.email)
  }
})

</script>

<style lang="scss">
.UserMenu-popper.el-popper {
  --el-popper-border-radius: 12px !important;
  width: 248px;
  box-sizing: border-box;
  border-radius: 12px !important;
  overflow: hidden;
}

.UserMenu-popper .el-dropdown__list {
  width: 100%;
  padding: 24px !important;
  box-sizing: border-box;
}

.UserMenu-popper .user-menu-list {
  width: 100%;
  padding: 0 !important;
  box-sizing: border-box;
}

.UserMenu-popper .user-menu-header {
  padding: 0 0 16px;
  box-sizing: border-box;
}

.UserMenu-popper .user-menu-title {
  width: 100%;
  max-width: 100%;
  min-height: 24px;
  white-space: normal;
  overflow-wrap: anywhere;
  line-height: 24px;
  box-sizing: border-box;
}

.UserMenu-popper .user-menu-icon {
  width: 24px;
  height: 24px;
  flex: 0 0 24px;
  object-fit: contain;
  margin-right: 14px;
}

.UserMenu-popper .user-menu-logout {
  width: 100%;
  height: 48px;
  padding-top: 12px;
  box-sizing: border-box;
  cursor: pointer;
}

.UserMenu-popper .user-menu-logout-icon {
  width: 24px;
  height: 24px;
  flex: 0 0 24px;
}

.UserMenu-popper .user-menu-divider {
  height: 1px;
  margin-bottom: 12px;
  background-color: var(--f4);
}

.UserMenu-popper .el-dropdown-menu__item.appheader-dropdown-item {
  width: 100%;
  height: 48px;
  padding: 0 !important;
  box-sizing: border-box;
  position: relative;
  z-index: 0;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
}

.UserMenu-popper .el-dropdown-menu__item.appheader-dropdown-item::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: -8px;
  width: calc(100% + 16px);
  border-radius: 4px;
  background-color: var(--f9);
  opacity: 0;
  pointer-events: none;
  z-index: 0;
}

.UserMenu-popper .el-dropdown-menu__item.appheader-dropdown-item > img,
.UserMenu-popper .el-dropdown-menu__item.appheader-dropdown-item > span {
  position: relative;
  z-index: 1;
}

.UserMenu-popper .el-dropdown-menu__item.appheader-dropdown-item:not(.is-disabled):hover {
  background-color: transparent !important;
  color: inherit !important;
}

.UserMenu-popper .el-dropdown-menu__item.appheader-dropdown-item.user-menu-item-active {
  background-color: transparent !important;
}

.UserMenu-popper .el-dropdown-menu__item.appheader-dropdown-item:not(.is-disabled):hover::before {
  opacity: 1;
}

.UserMenu-popper .el-dropdown-menu__item.appheader-dropdown-item.user-menu-item-active::before {
  opacity: 1;
}
</style>
